<p-dialog
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '96vw' }"
  [dismissableMask]="true"
  (onHide)="close()">
  <ng-template pTemplate="header">
    <div class="flex items-center gap-8 text-2xl font-[600] text-[var(--p-slate-900)]">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="none">
        <use xlink:href="assets/images/icon-library.svg#sparkles"></use>
      </svg>
      AI Agents
    </div>
  </ng-template>

  <div class="ai-gallery">
    <div class="ai-gallery__grid">
      @for (agent of agents; track agent.title) {
        <button type="button" class="ai-gallery-card" (click)="select(agent)">
          <span class="ai-gallery-card__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <use [attr.xlink:href]="'assets/images/icon-library.svg#' + agent.icon"></use>
            </svg>
          </span>

          <span class="ai-gallery-card__category">{{ agent.category }}</span>
          <span class="ai-gallery-card__title">{{ agent.title }}</span>
          <span class="ai-gallery-card__desc">{{ agent.description }}</span>

          <span class="ai-gallery-card__footer">
            <span class="ai-gallery-card__tags">
              @for (tag of agent.tags; track tag) {
                <span class="ai-gallery-card__tag">{{ tag }}</span>
              }
            </span>

            <span
              class="ai-gallery-card__autonomy"
              [class.ai-gallery-card__autonomy--approval]="agent.autonomy === 'approval'">
              @if (agent.autonomy === 'approval') {
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <use xlink:href="assets/images/icon-library.svg#circle-alert"></use>
                </svg>
              }
              {{ agent.autonomyLabel }}
            </span>
          </span>
        </button>
      }
    </div>
  </div>
</p-dialog>
